module.exports = __webpack_public_path__ + "img/pencil-square.ad42c6d3.svg";